import React from "react";
import Modal from "../../lib/ModalWindow/Modal";
import styles from "./WishlistIsFullModal.module.scss";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useWishlistSelector} from "../../../store";
import {updateWishlistState} from "../../../store/slices/wishlishSlice";

const WishlistIsFullModal: React.FC = () => {
  const {isWishlistFullModalShown} = useWishlistSelector();
  const dispatch = useAppDispatch();
  const {t} = useTranslation();

  return (
    <Modal
      isVisible={isWishlistFullModalShown}
      closeFunction={() => dispatch(updateWishlistState({isWishlistFullModalShown: false}))}
    >
      <h2>{t("wishlist.wishlistFull")}</h2>
      <p className={styles.subtitle}>{t("wishlist.maxItemNumber")}</p>
      <a className={styles.link} href={t("url.wishlistLink")} title={t("wishlist.gotToWishlist")}>
        {t("wishlist.gotToWishlist")}
      </a>
    </Modal>
  );
};

export default WishlistIsFullModal;
